import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Margin } from '../types/type';

@Component({
  selector: 'custom-toggle-group',
  templateUrl: './custom-toggle-group.component.html',
  styleUrls: ['./custom-toggle-group.component.scss']
})
export class CustomToggleGroupComponent implements OnInit {

  @Input() multiple: boolean = false;
  @Input() disabled: boolean = false;
  @Input() activeClass: boolean = false;
  @Input() label: string;
  @Input() tabIndex: number;
  @Input() margin: Margin = 'medium';
  @Input() listToggle: any = [];
  @Input() value: any;
  @Output() valueChange = new EventEmitter();

  constructor() {
    //Constructor
  }

  ngOnInit(): void {
    //onInit
  }

  onChangeValue(event){
    this.value = event;
    this.valueChange.emit(event);
  }

}
